import { CircularProgress, Stack, Typography } from "@mui/material";

const PortalLoading = ({
  message = "Loading portal...",
  minHeight = "100vh",
}) => {
  return (
    <Stack
      sx={{
        minHeight,
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      <CircularProgress size={24} />
      <Typography variant="body2">{message}</Typography>
    </Stack>
  );
};

export default PortalLoading;
